import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useRef, useState } from "react";
import StatusBadge from "components/StatusBadge";
import Popper from "components/Popper";
import StatusModal from "components/StatusModal";
import { IStatus } from "dto/IStatus";
import { ItemKind } from "dto/IKindItems";
import PackageBar from "components/PackageBar";
import { Tooltip } from "@mui/material";
import { randomString } from "utils/randomString";
import { ListType } from "dto/ListType";
import SendStatusBadge from "components/SendStatusBadge";
import { ESendStatus } from "components/IconsState/typings";
import { useTranslation } from "react-i18next";

const StatusCell: FC<Props> = ({ element, statuses }) => {
  const { t } = useTranslation();
  const refStatus = useRef(null);

  const isWaitingToReceive =
    element.IsIncoming &&
    !element.ReceiveDate &&
    (element.Kind === ItemKind.CourtPortalDeliverance ||
      element.Kind === ItemKind.EDeliveryMessage);

  const [showStatus, setShowStatus] = useState<boolean>(false);
  const [status, setStatus] = useState<IStatus>(
    statuses.find((s) => s.Id === element.StatusId)
  );

  const handleStatusUpdate = (status?: IStatus) => {
    setStatus(status);
    setShowStatus(false);
  };

  if (isWaitingToReceive) {
    return (
      <div className={styles.progress}>
        <PackageBar
          id={element.Id}
          date={element.SendDate}
          expirationDate={element.ExpirationTime}
          totalDays={element.ExpirationDays}
          expired={element.Expired}
        />
      </div>
    );
  }

  return (
    <div className={styles.status}>
      {
        <div ref={refStatus} className={styles.badge}>
          {element.Kind === ItemKind.EDeliveryMessage && (
            <SendStatusBadge
              status={ESendStatus.WAITING}
              edeliveryEvent={element.NewestEvidenceEvent}
              showName={true}
            ></SendStatusBadge>
          )}
          {element.ReceiveDate &&
            element.Kind === ItemKind.CourtPortalDeliverance && (
              <StatusBadge
                status={{
                  Id: randomString(),
                  Name: t("statuses.received"),
                  Color: 6,
                  Type: ListType.Incoming,
                }}
                showName={true}
              />
            )}
          {!element.ReceiveDate &&
            element.SendDate &&
            element.Kind === ItemKind.CourtPortalDeliverance && (
              <StatusBadge
                status={{
                  Id: randomString(),
                  Name: t("statuses.sent"),
                  Color: 2,
                  Type: ListType.Incoming,
                }}
                showName={true}
              />
            )}

          {element.StatusId &&
            element.Kind !== ItemKind.EDeliveryMessage &&
            element.Kind !== ItemKind.CourtPortalDeliverance && (
              <div
                ref={refStatus}
                className={styles.badge}
                onClick={(e) => {
                  setShowStatus(!showStatus);
                  e.stopPropagation();
                }}
              >
                {status && <StatusBadge status={status} showName={true} />}
              </div>
            )}

          {!element.StatusId &&
            element.Kind !== ItemKind.EDeliveryMessage &&
            element.Kind !== ItemKind.CourtPortalDeliverance && (
              <Tooltip title={t("statuses.setStatus")}>
                <div>
                  <div
                    ref={refStatus}
                    className={styles.fakeBadge}
                    onClick={(e) => {
                      setShowStatus(!showStatus);
                      e.stopPropagation();
                    }}
                  >
                    ...
                  </div>
                </div>
              </Tooltip>
            )}

          {showStatus && (
            <Popper
              anchorEl={refStatus?.current}
              open={showStatus}
              setOpen={setShowStatus}
            >
              <StatusModal
                item={element}
                toggle={setShowStatus}
                selectedStatus={status}
                afterUpdate={handleStatusUpdate}
              />
            </Popper>
          )}
        </div>
      }
    </div>
  );
};

export default StatusCell;
